import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import Home from "../views/Home.vue";
import { routes as accountManagement } from './account-management';
import { routes as core } from './core';
import { routes as urlshortener } from './url-shortener';

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
	...core,
	...accountManagement,
	...urlshortener,
];



const router = new VueRouter({
	mode: "history",
	base: process.env.BASE_URL,
	routes,
});

export default router;
